/*
  Complete Your Set — the per-set checklist.

  The list itself is server-rendered. This adds the three things that need a
  browser: ticking, filtering, and adding the gaps to the basket. With this file
  missing you still get a readable list of every printing in the set and what it
  costs — the controls simply never appear, which is why they start hidden
  rather than being disabled here.

  State is the same localStorage key the index reads, holding slot ids like
  `bulk:swsh7:1:reverse`. Nothing is sent anywhere and there is no account.
*/

(function () {
  'use strict'

  var KEY = 'quantum-cards.owned'

  var root = document.querySelector('[data-checklist]')
  if (!root) return

  var list = root.querySelector('[data-slots]')
  var controls = root.querySelector('[data-controls]')
  var empty = root.querySelector('[data-empty]')
  var mini = root.querySelector('[data-mini]')
  var stats = document.querySelector('[data-checklist-stats]')
  var slots = [].slice.call(root.querySelectorAll('.slot'))
  if (!slots.length) return

  var owned = read()

  /* ── Storage ─────────────────────────────────────────────────────────── */

  function read() {
    try {
      var raw = localStorage.getItem(KEY)
      var list = raw ? JSON.parse(raw) : []
      var set = Object.create(null)
      if (Array.isArray(list)) for (var i = 0; i < list.length; i++) set[list[i]] = true
      return set
    } catch (e) {
      return Object.create(null)
    }
  }

  function write() {
    try {
      localStorage.setItem(KEY, JSON.stringify(Object.keys(owned)))
    } catch (e) {
      // Private browsing or a full quota. Ticks still work for this visit;
      // silently losing them later is better than blocking the page.
    }
  }

  /* ── Order ───────────────────────────────────────────────────────────────
     Collection order is whatever Shopify's sort gives us, which is not card
     order. Sorting here rather than relying on a collection setting means the
     list is right regardless of how the collection is configured — and if this
     script never runs, the list is merely out of order, not missing. */

  slots.sort(function (a, b) {
    var n = Number(a.dataset.number) - Number(b.dataset.number)
    if (n) return n
    return a.dataset.slot.localeCompare(b.dataset.slot)
  })
  var frag = document.createDocumentFragment()
  slots.forEach(function (s) { frag.appendChild(s) })
  list.appendChild(frag)

  /* ── Ticking ─────────────────────────────────────────────────────────── */

  slots.forEach(function (slot) {
    var id = 'bulk:' + slot.dataset.slot
    var tick = slot.querySelector('[data-tick]')

    if (owned[id]) {
      tick.checked = true
      slot.classList.add('slot--owned')
    }

    tick.addEventListener('change', function () {
      if (tick.checked) {
        owned[id] = true
        slot.classList.add('slot--owned')
      } else {
        delete owned[id]
        slot.classList.remove('slot--owned')
      }
      write()
      refresh()
    })
  })

  /* ── Search ──────────────────────────────────────────────────────────────
     Matches name, card number and printing. Built once at load: 264 rows is
     small, but re-reading the DOM on every keystroke is the kind of thing that
     feels fine on a desktop and janky on a phone. */

  var query = ''
  var haystack = slots.map(function (slot) {
    return (
      slot.querySelector('.slot__name').textContent + ' ' +
      slot.querySelector('.slot__meta').textContent
    )
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim()
  })

  var search = root.querySelector('[data-search]')
  if (search) {
    search.addEventListener('input', function () {
      query = search.value.toLowerCase().trim()
      refresh()
    })
    // Escape clears, so you can get back to the whole set without reaching for
    // the mouse mid-way through a stack of cards.
    search.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && query) {
        e.stopPropagation()
        search.value = ''
        query = ''
        refresh()
      }
    })
  }

  /* ── Filtering ───────────────────────────────────────────────────────── */

  var filter = 'all'

  root.querySelectorAll('[data-filter]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      filter = btn.getAttribute('data-filter')
      root.querySelectorAll('[data-filter]').forEach(function (b) {
        b.classList.toggle('is-on', b === btn)
      })
      refresh()
    })
  })

  /* ── Adding to the basket ────────────────────────────────────────────────
     One shared path for the per-row buttons and the bulk one, so the cart is
     always built the same way. */

  function cartAdd(items) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
    return fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      if (!r.ok) throw new Error('cart')
      return fetch(base + 'cart.js').then(function (c) { return c.json() })
    })
  }

  /** Keeps the header count honest without a page reload. */
  function paintCount(cart) {
    var el = document.querySelector('[data-cart-count]')
    if (!el || !cart) return
    el.textContent = cart.item_count
    el.classList.toggle('is-empty', cart.item_count === 0)
  }

  /* Per-row add. Ticking says what you own; this says what you want to buy —
     they are deliberately separate, and owning something does not stop you
     buying another copy. */
  slots.forEach(function (slot) {
    var btn = slot.querySelector('[data-add]')
    if (!btn) return

    if (slot.dataset.available !== 'true') return // stays disabled, reads "Sold out"
    btn.disabled = false

    btn.addEventListener('click', function () {
      btn.disabled = true
      var was = btn.textContent
      btn.textContent = '…'

      cartAdd([{ id: Number(slot.dataset.variant), quantity: 1 }])
        .then(function (cart) {
          paintCount(cart)
          btn.textContent = 'Added'
          slot.classList.add('slot--added')
          setTimeout(function () {
            btn.textContent = was
            btn.disabled = false
            slot.classList.remove('slot--added')
          }, 1600)
        })
        .catch(function () {
          btn.textContent = 'Failed'
          setTimeout(function () {
            btn.textContent = was
            btn.disabled = false
          }, 1600)
        })
    })
  })

  /* ── Add the gaps ────────────────────────────────────────────────────── */

  var addBtn = root.querySelector('[data-add-missing]')
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      var items = missing()
        .filter(function (s) { return s.dataset.available === 'true' })
        .map(function (s) { return { id: Number(s.dataset.variant), quantity: 1 } })

      if (!items.length) return

      addBtn.disabled = true
      addBtn.textContent = 'Adding ' + items.length + '…'

      cartAdd(items)
        .then(function () {
          window.location.href = (window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root : '/') + 'cart'
        })
        .catch(function () {
          addBtn.disabled = false
          addBtn.textContent = 'Could not add — try again'
        })
    })
  }

  /* ── Recalculate ─────────────────────────────────────────────────────── */

  function missing() {
    return slots.filter(function (s) { return !owned['bulk:' + s.dataset.slot] })
  }

  function refresh() {
    var ownedCount = 0
    var shown = 0

    slots.forEach(function (slot, i) {
      var isOwned = !!owned['bulk:' + slot.dataset.slot]
      // Counted before any filtering — the totals describe the whole set, not
      // whatever happens to be on screen.
      if (isOwned) ownedCount++

      var passesFilter = filter === 'all' || (filter === 'owned') === isOwned
      var passesSearch = !query || haystack[i].indexOf(query) !== -1

      var show = passesFilter && passesSearch
      slot.hidden = !show
      if (show) shown++
    })

    if (empty) {
      empty.hidden = shown !== 0
      if (shown === 0) {
        empty.textContent = query
          ? (empty.dataset.msgSearch || 'No matches for “%s”.').replace('%s', search.value.trim())
          : empty.dataset.msgFilter || ''
      }
    }

    if (stats) {
      var total = slots.length
      var pct = total ? Math.round((ownedCount / total) * 100) : 0
      set(stats, '[data-owned]', String(ownedCount))
      set(stats, '[data-percent]', pct + '%')

      /*
        There was a third stat here — "To finish", the cost of every printing
        not yet ticked. Removed 2026-08-23 for reading as a price quote rather
        than a tally. The Add button below is the only thing on this page that
        talks about money now, which is right: it is the only one that knows
        what we can actually supply today.
      */
    }

    /*
      The button says what it can DO, never what it thinks the shop has.

      An earlier version said "None in stock yet" whenever nothing was
      addable — which is true when every variant is at zero stock, but reads as
      "the shop is empty" in the far more common case where the collector has
      simply ticked everything we currently hold. Same words, opposite meaning,
      and it made the button look broken as you ticked through a set.

      The note underneath carries the explanation; the button stays literal.
    */
    if (addBtn) {
      var missingTotal = missing().length
      var buyable = missing().filter(function (s) { return s.dataset.available === 'true' }).length

      addBtn.disabled = buyable === 0
      addBtn.textContent =
        missingTotal === 0 ? 'Set complete'
        : buyable === 0 ? 'Nothing available to add'
        : 'Add ' + buyable + ' missing to basket'
    }

    /* Compact readout for the sticky bar, so progress stays visible while
       scrolling a 264-row list. */
    if (mini) {
      var pctNow = slots.length ? Math.round((ownedCount / slots.length) * 100) : 0
      mini.textContent = ownedCount + ' / ' + slots.length + ' · ' + pctNow + '%'
    }
  }

  function set(scope, sel, value) {
    var el = scope.querySelector(sel)
    if (el) el.textContent = value
  }

  controls.hidden = false
  refresh()
})()
